import { render } from "./AreasCocinaList.vue?vue&type=template&id=c13b7de2&scoped=true"
import script from "./AreasCocinaList.vue?vue&type=script&lang=js"
export * from "./AreasCocinaList.vue?vue&type=script&lang=js"

import "./AreasCocinaList.vue?vue&type=style&index=0&id=c13b7de2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c13b7de2"]])

export default __exports__